module.exports = __webpack_public_path__ + "static/stateseal-ca03358e741c3d8986c2dac36a7e469a.png";